import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/down.png'
import _imports_1 from '../../assets/performance/banner.png'
import _imports_2 from '../../assets/performance/banner3.png'
import _imports_3 from '../../assets/performance/footer.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-52be565a")

_pushScopeId("data-v-52be565a")
const _hoisted_1 = {
  class: "Ecard",
  id: "trendChart"
}
const _hoisted_2 = { class: "testMain" }
const _hoisted_3 = { class: "fitter_title" }
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, " 删除 ", -1)
const _hoisted_5 = { class: "dialog-footer" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("发送报告")
const _hoisted_9 = /*#__PURE__*/_createVNode("span", null, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1)
const _hoisted_10 = {
  key: 0,
  class: "editRecipient"
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" 可按如下任一形式批量添加： ")
const _hoisted_12 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_13 = /*#__PURE__*/_createTextVNode("1、zhangsan;lisi;wangwu ")
const _hoisted_14 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode("2、zhangsan(张三);lisi(李四);wangwu(王五) ")
const _hoisted_16 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode("3、zhangsan(张三) <zhangsan@tencent.com>;lisi(李四) <lisi@tencent.com>; wangwu(王五) <wangwu@tencent.com> ")
const _hoisted_18 = /*#__PURE__*/_createVNode("span", null, "发送报告", -1)
const _hoisted_19 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_20 = /*#__PURE__*/_createVNode("div", {
  class: "versionGeneration versionGeneration2",
  style: {}
}, [
  /*#__PURE__*/_createVNode("p", null, [
    /*#__PURE__*/_createVNode("b")
  ])
], -1)
const _hoisted_21 = { id: "perf_report" }
const _hoisted_22 = {
  key: 0,
  class: "spacName"
}
const _hoisted_23 = /*#__PURE__*/_createVNode("img", {
  class: "banner",
  src: _imports_1,
  alt: ""
}, null, -1)
const _hoisted_24 = {
  key: 1,
  class: "spacName"
}
const _hoisted_25 = /*#__PURE__*/_createVNode("img", {
  class: "banner",
  src: _imports_2,
  alt: ""
}, null, -1)
const _hoisted_26 = { class: "spacName" }
const _hoisted_27 = { class: "gameTable" }
const _hoisted_28 = {
  rowspan: 3,
  class: "gameIcon"
}
const _hoisted_29 = {
  colspan: 3,
  class: "game_name"
}
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" 版本: ")
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" 测试时间: ")
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" 创建者: ")
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" 风险等级: ")
const _hoisted_34 = /*#__PURE__*/_createVNode("td", null, [
  /*#__PURE__*/_createTextVNode(" 测试内容: "),
  /*#__PURE__*/_createVNode("span", null, "UI控件性能")
], -1)
const _hoisted_35 = /*#__PURE__*/_createTextVNode(" 测试平台: ")
const _hoisted_36 = { style: {"margin-bottom":"20px"} }
const _hoisted_37 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("一、测试概括")
], -1)
const _hoisted_38 = /*#__PURE__*/_createVNode("h6", null, [
  /*#__PURE__*/_createVNode("span", { class: "subTitle spacName" }, "◆"),
  /*#__PURE__*/_createTextVNode("测试内容")
], -1)
const _hoisted_39 = { class: "spacName" }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = /*#__PURE__*/_createTextVNode("(上次")
const _hoisted_42 = /*#__PURE__*/_createTextVNode("，")
const _hoisted_43 = { key: 1 }
const _hoisted_44 = /*#__PURE__*/_createVNode("h6", null, [
  /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆"),
  /*#__PURE__*/_createTextVNode("FPS性能趋势")
], -1)
const _hoisted_45 = /*#__PURE__*/_createVNode("h6", { style: {"margin":"10px 0"} }, [
  /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆"),
  /*#__PURE__*/_createTextVNode("PSS性能趋势 ")
], -1)
const _hoisted_46 = /*#__PURE__*/_createVNode("h5", { class: "TitleStyle" }, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("三、详细机型测试数据")
], -1)
const _hoisted_47 = { style: {"color":"#2b64bb","font-weight":"bold"} }
const _hoisted_48 = /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆", -1)
const _hoisted_49 = /*#__PURE__*/_createTextVNode(" 数据链接：")
const _hoisted_50 = {
  style: {"margin-top":"8px"},
  class: "gameTable1"
}
const _hoisted_51 = { style: {"background":"#5d99d5"} }
const _hoisted_52 = { class: "spacName" }
const _hoisted_53 = /*#__PURE__*/_createVNode("h6", null, [
  /*#__PURE__*/_createVNode("span", { class: "subTitle spacName" }, "◆"),
  /*#__PURE__*/_createTextVNode("测试机型")
], -1)
const _hoisted_54 = {
  class: "gameTable1",
  style: {"margin-bottom":"1rem"}
}
const _hoisted_55 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("td", null, "档位"),
    /*#__PURE__*/_createVNode("td", null, "机型"),
    /*#__PURE__*/_createVNode("td", null, "系统版本"),
    /*#__PURE__*/_createVNode("td", null, "GPU型号"),
    /*#__PURE__*/_createVNode("td", null, "帧率设置"),
    /*#__PURE__*/_createVNode("td", null, "分辨率")
  ])
], -1)
const _hoisted_56 = /*#__PURE__*/_createVNode("div", { class: "footer" }, [
  /*#__PURE__*/_createVNode("img", {
    src: _imports_3,
    alt: ""
  })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_main, null, {
            default: _withId(() => [
              _createVNode("div", _hoisted_1, [
                _createVNode("div", _hoisted_2, [
                  _createVNode("div", _hoisted_3, [
                    _createVNode(_component_el_form, {
                      inline: true,
                      size: "mini",
                      class: "spacForm queryReport"
                    }, {
                      default: _withId(() => [
                        _createVNode(_component_el_form_item, { label: "报告名称" }, {
                          default: _withId(() => [
                            _createVNode(_component_el_select, {
                              modelValue: _ctx.report_id,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.report_id = $event)),
                              placeholder: "请选择",
                              onChange: _ctx.change_name_search
                            }, {
                              default: _withId(() => [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.nameList, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: item.id,
                                    label: 
                        item.report_name +
                        '-[' +
                        item.create_date.replace('T', ' ') +
                        ']'
                      ,
                                    value: item.id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onChange"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_form_item, null, {
                          default: _withId(() => [
                            _createVNode(_component_el_popconfirm, {
                              onConfirm: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleDelete())),
                              title: "确认删除该报告？",
                              placement: "top"
                            }, {
                              reference: _withId(() => [
                                _createVNode(_component_el_button, {
                                  style: {"margin-right":"10px"},
                                  size: "mini",
                                  type: "info",
                                  disabled: _ctx.get_is_super
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "暂无管理员权限",
                                      placement: "top",
                                      disabled: !_ctx.get_is_super
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_4
                                      ]),
                                      _: 1
                                    }, 8, ["disabled"])
                                  ]),
                                  _: 1
                                }, 8, ["disabled"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_dialog, {
                              modelValue: _ctx.dialogFormVisible1,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.dialogFormVisible1 = $event))
                            }, {
                              footer: _withId(() => [
                                _createVNode("span", _hoisted_5, [
                                  _createVNode(_component_el_button, {
                                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.dialogFormVisible1 = false))
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_6
                                    ]),
                                    _: 1
                                  }),
                                  _createVNode(_component_el_button, {
                                    type: "primary",
                                    onClick: _ctx.dialogFormVisible2
                                  }, {
                                    default: _withId(() => [
                                      _hoisted_7
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"])
                                ])
                              ]),
                              default: _withId(() => [
                                _withDirectives(_createVNode(_component_el_form, null, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_form_item, {
                                      class: "reportName",
                                      label: "报告名称",
                                      "label-width": _ctx.formLabelWidth
                                    }, {
                                      default: _withId(() => [
                                        _createVNode(_component_el_input, {
                                          class: "report-input",
                                          modelValue: _ctx.form1.name,
                                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form1.name = $event)),
                                          autocomplete: "off",
                                          width: "500"
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }, 8, ["label-width"])
                                  ]),
                                  _: 1
                                }, 512), [
                                  [_vShow, _ctx.dialogFormVisible1]
                                ])
                              ]),
                              _: 1
                            }, 8, ["modelValue"]),
                            _createVNode(_component_el_button, {
                              type: "primary",
                              onClick: _ctx.sendOut,
                              class: "down_img"
                            }, {
                              default: _withId(() => [
                                _hoisted_8,
                                _hoisted_9
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  (_ctx.edit)
                    ? (_openBlock(), _createBlock("div", _hoisted_10, [
                        _createVNode(_component_el_form, {
                          "label-position": "left",
                          "label-width": "100px",
                          model: _ctx.formMail,
                          size: "mini"
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_form_item, { label: "邮件标题" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.formMail.title,
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.formMail.title = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "邮件发件人" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_tooltip, { placement: "bottom" }, {
                                  content: _withId(() => [
                                    _createTextVNode(" 指定的邮件发件人需要位于公司TOF发件人名单,否则无法发送邮件。默认邮件发件人" + _toDisplayString(_ctx.formMail.Sender), 1)
                                  ]),
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.formMail.Sender,
                                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.formMail.Sender = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "邮件收件人" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_tooltip, { placement: "bottom" }, {
                                  content: _withId(() => [
                                    _hoisted_11,
                                    _hoisted_12,
                                    _hoisted_13,
                                    _hoisted_14,
                                    _hoisted_15,
                                    _hoisted_16,
                                    _hoisted_17
                                  ]),
                                  default: _withId(() => [
                                    _createVNode(_component_el_input, {
                                      modelValue: _ctx.formMail.addressee,
                                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.formMail.addressee = $event))
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_form_item, { label: "邮件抄送人" }, {
                              default: _withId(() => [
                                _createVNode(_component_el_input, {
                                  modelValue: _ctx.formMail.CC_List,
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.formMail.CC_List = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_popconfirm, {
                              title: "确认发送报告吗？",
                              onConfirm: _cache[10] || (_cache[10] = ($event: any) => (_ctx.save_report(false))),
                              placement: "top"
                            }, {
                              reference: _withId(() => [
                                _createVNode(_component_el_button, {
                                  type: "primary",
                                  disabled: _ctx.get_is_super,
                                  size: "mini"
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_tooltip, {
                                      effect: "dark",
                                      content: "暂无管理员权限",
                                      placement: "top",
                                      disabled: !_ctx.get_is_super
                                    }, {
                                      default: _withId(() => [
                                        _hoisted_18
                                      ]),
                                      _: 1
                                    }, 8, ["disabled"])
                                  ]),
                                  _: 1
                                }, 8, ["disabled"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_button, {
                              size: "mini",
                              type: "info",
                              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.edit = false))
                            }, {
                              default: _withId(() => [
                                _hoisted_19
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["model"]),
                        _hoisted_20
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode("div", _hoisted_21, [
                    (
                  _ctx.localProject !== 34 &&
                  _ctx.localProject !== 40 &&
                  _ctx.localProject !== 47
                )
                      ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_22, [
                          _hoisted_23
                        ], 512)), [
                          [_directive_loading, _ctx.loading]
                        ])
                      : _createCommentVNode("", true),
                    (
                  _ctx.localProject === 34 ||
                  _ctx.localProject === 40 ||
                  _ctx.localProject === 47
                )
                      ? _withDirectives((_openBlock(), _createBlock("div", _hoisted_24, [
                          _hoisted_25
                        ], 512)), [
                          [_directive_loading, _ctx.loading]
                        ])
                      : _createCommentVNode("", true),
                    _createVNode("div", _hoisted_26, [
                      _withDirectives(_createVNode("table", _hoisted_27, [
                        _createVNode("tr", null, [
                          _createVNode("td", _hoisted_28, [
                            _createVNode("img", {
                              src: _ctx.get_skin_data.project.icon
                            }, null, 8, ["src"])
                          ]),
                          _createVNode("td", _hoisted_29, " 【" + _toDisplayString(_ctx.get_skin_data.project.project_name) + "】 ", 1)
                        ]),
                        _createVNode("tr", null, [
                          _createVNode("td", null, [
                            _hoisted_30,
                            _createVNode("span", null, _toDisplayString(_ctx.get_skin_data.base.version), 1)
                          ]),
                          _createVNode("td", null, [
                            _hoisted_31,
                            _createVNode("span", null, _toDisplayString(_ctx.get_skin_data.base.date), 1)
                          ]),
                          _createVNode("td", null, [
                            _hoisted_32,
                            _createVNode("span", null, _toDisplayString(_ctx.get_skin_data.base.creator), 1)
                          ])
                        ]),
                        _createVNode("tr", null, [
                          _createVNode("td", null, [
                            _hoisted_33,
                            _createVNode("span", {
                              style: {
                          color: _ctx.riskLv === '高风险' ? 'red' : '#00b050',
                        }
                            }, [
                              _createVNode("b", null, _toDisplayString(_ctx.riskLv), 1)
                            ], 4)
                          ]),
                          _hoisted_34,
                          _createVNode("td", null, [
                            _hoisted_35,
                            _createVNode("span", null, _toDisplayString(_ctx.get_skin_data?.device_type), 1)
                          ])
                        ])
                      ], 512), [
                        [_directive_loading, _ctx.loading]
                      ])
                    ]),
                    _createVNode("div", _hoisted_36, [
                      _hoisted_37,
                      _hoisted_38,
                      _createVNode("ul", null, [
                        _createVNode("li", null, "UI控件数量:" + _toDisplayString(_ctx.get_skin_data.base.skin_num), 1),
                        _createVNode("li", null, "测试流水线:" + _toDisplayString(_ctx.get_pipeline), 1)
                      ]),
                      _createVNode("div", _hoisted_39, [
                        _createVNode(_component_el_table, {
                          "header-cell-style": {
                      background: '#f5f7fa',
                      height: '31px',
                      padding: '0px',
                      fontWeight: 'bold',
                      color: '#303133',
                    },
                          data: _ctx.risk_list
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_table_column, {
                              align: "center",
                              label: "性能数据变化情况"
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_table_column, {
                                  width: "160",
                                  label: "机型"
                                }, {
                                  default: _withId((scope) => [
                                    _createVNode("span", null, _toDisplayString(scope.row.name), 1)
                                  ]),
                                  _: 1
                                }),
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.risk_thead, (item, index) => {
                                  return (_openBlock(), _createBlock(_component_el_table_column, {
                                    width: item != '性能指标*内存峰值' ? 220 : 300,
                                    key: index,
                                    label: item
                                  }, {
                                    default: _withId((scope) => [
                                      (scope.row.value[item].length != 0)
                                        ? (_openBlock(), _createBlock("div", _hoisted_40, [
                                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(scope.row.value[item], (k, i) => {
                                              return (_openBlock(), _createBlock("div", { key: i }, [
                                                _createTextVNode(_toDisplayString(i + 1) + "、" + _toDisplayString(k.label), 1),
                                                _createVNode("span", null, _toDisplayString(k.new), 1),
                                                _hoisted_41,
                                                _createVNode("span", null, _toDisplayString(k.old), 1),
                                                _hoisted_42,
                                                _createVNode("span", {
                                                  style: 'color:' + _ctx.testColor(k.res, item)
                                                }, _toDisplayString(k.res) + ")", 5)
                                              ]))
                                            }), 128))
                                          ]))
                                        : (_openBlock(), _createBlock("div", _hoisted_43, "各场景变化不大"))
                                    ]),
                                    _: 2
                                  }, 1032, ["width", "label"]))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["data"])
                      ]),
                      _hoisted_44,
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.get_skin_data.all_echart_data, (item, index) => {
                        return (_openBlock(), _createBlock(_component_el_card, { key: index }, {
                          default: _withId(() => [
                            _createVNode("div", {
                              id: item.scene + 'fps',
                              style: {"width":"100%","height":"350px"}
                            }, null, 8, ["id"])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128)),
                      _hoisted_45,
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.get_skin_data.all_echart_data, (item, index) => {
                        return (_openBlock(), _createBlock(_component_el_card, { key: index }, {
                          default: _withId(() => [
                            _createVNode("div", {
                              id: item.scene + 'avg_pss',
                              style: {"width":"100%","height":"350px"}
                            }, null, 8, ["id"])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _hoisted_46,
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.get_skin_data.model_list, (value, key, index) => {
                      return (_openBlock(), _createBlock("div", {
                        style: {"margin-top":"8px"},
                        key: index
                      }, [
                        _createVNode("h6", _hoisted_47, [
                          _hoisted_48,
                          _createTextVNode(" " + _toDisplayString(key), 1)
                        ]),
                        _createVNode("p", null, [
                          _hoisted_49,
                          _createVNode("a", {
                            href: _ctx.get_url(value.url),
                            target: "_blank"
                          }, _toDisplayString(_ctx.get_url(value.url)), 9, ["href"])
                        ]),
                        _createVNode("table", _hoisted_50, [
                          _createVNode("thead", _hoisted_51, [
                            _createVNode("tr", null, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.gameList, (item) => {
                                return (_openBlock(), _createBlock("td", { key: item }, _toDisplayString(item), 1))
                              }), 128))
                            ])
                          ]),
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(value.data, (item, k) => {
                            return (_openBlock(), _createBlock("tbody", { key: k }, [
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(item, (v, i) => {
                                return (_openBlock(), _createBlock("tr", { key: i }, [
                                  _createVNode("td", null, _toDisplayString(v.skin_name), 1),
                                  _createVNode("td", null, [
                                    _createVNode("span", {
                                      style: 'color:' + _ctx.get_color('avg_fps', v.avg_fps)
                                    }, _toDisplayString(v.avg_fps), 5),
                                    _createVNode("span", {
                                      style: 
                            'color:' +
                            _ctx.getNum(v.avg_fps, v.old.avg_fps, 'avg_fps')[1]
                          
                                    }, _toDisplayString(_ctx.getNum(v.avg_fps, v.old.avg_fps, "avg_fps")[0]), 5)
                                  ]),
                                  _createVNode("td", null, [
                                    _createTextVNode(_toDisplayString(v.var_fps), 1),
                                    _createVNode("span", {
                                      style: 
                            'color:' +
                            _ctx.getNum(v.var_fps, v.old.var_fps, 'var_fps')[1]
                          
                                    }, _toDisplayString(_ctx.getNum(v.var_fps, v.old.var_fps, "var_fps")[0]), 5)
                                  ]),
                                  _createVNode("td", null, [
                                    _createVNode("span", {
                                      style: 'color:' + _ctx.get_color('lag_pcnt', v.lag_pcnt)
                                    }, _toDisplayString(v.lag_pcnt), 5),
                                    _createVNode("span", {
                                      style: 
                            'color:' +
                            _ctx.getNum(v.lag_pcnt, v.old.lag_pcnt, 'lag_pcnt')[1]
                          
                                    }, _toDisplayString(_ctx.getNum(v.lag_pcnt, v.old.lag_pcnt, "lag_pcnt")[0]), 5)
                                  ]),
                                  _createVNode("td", null, [
                                    _createVNode("span", {
                                      style: 
                            'color:' +
                            _ctx.get_color('fps_lt_10_pcnt', v.fps_lt_10_pcnt)
                          
                                    }, _toDisplayString(v.fps_lt_10_pcnt), 5),
                                    _createVNode("span", null, _toDisplayString(_ctx.getNum(v.fps_lt_10_pcnt, v.old.fps_lt_10_pcnt)[0]), 1)
                                  ]),
                                  _createVNode("td", null, [
                                    _createVNode("span", {
                                      style: 
                            'color:' +
                            _ctx.get_color('fps_lt_18_pcnt', v.fps_lt_18_pcnt)
                          
                                    }, _toDisplayString(v.fps_lt_18_pcnt), 5),
                                    _createVNode("span", null, _toDisplayString(_ctx.getNum(v.fps_lt_18_pcnt, v.old.fps_lt_18_pcnt)[0]), 1)
                                  ]),
                                  _createVNode("td", null, [
                                    _createVNode("span", {
                                      style: 
                            'color:' +
                            _ctx.get_color('fps_lt_25_pcnt', v.fps_lt_25_pcnt)
                          
                                    }, _toDisplayString(v.fps_lt_25_pcnt), 5),
                                    _createVNode("span", null, _toDisplayString(_ctx.getNum(v.fps_lt_25_pcnt, v.old.fps_lt_25_pcnt)[0]), 1)
                                  ]),
                                  _createVNode("td", null, [
                                    _createVNode("span", {
                                      style: 'color:' + _ctx.get_color('avg_cpu', v.avg_cpu)
                                    }, _toDisplayString(v.avg_cpu), 5),
                                    _createVNode("span", null, _toDisplayString(_ctx.getNum(v.avg_cpu, v.old.avg_cpu)[0]), 1)
                                  ]),
                                  _createVNode("td", null, [
                                    _createVNode("span", {
                                      style: 
                            'color:' +
                            _ctx.get_color('cpu_lt_60_pcnt', v.cpu_lt_60_pcnt)
                          
                                    }, _toDisplayString(v.cpu_lt_60_pcnt), 5),
                                    _createVNode("span", null, _toDisplayString(_ctx.getNum(v.cpu_lt_60_pcnt, v.old.cpu_lt_60_pcnt)[0]), 1)
                                  ]),
                                  _createVNode("td", null, [
                                    _createVNode("span", {
                                      style: 
                            'color:' +
                            _ctx.get_color('cpu_lt_80_pcnt', v.cpu_lt_80_pcnt)
                          
                                    }, _toDisplayString(v.cpu_lt_80_pcnt), 5),
                                    _createVNode("span", null, _toDisplayString(_ctx.getNum(v.cpu_lt_80_pcnt, v.old.cpu_lt_80_pcnt)[0]), 1)
                                  ]),
                                  _createVNode("td", null, [
                                    _createVNode("span", {
                                      style: 'color:' + _ctx.get_color('max_pss', v.max_pss)
                                    }, _toDisplayString(v.max_pss), 5),
                                    _createVNode("span", {
                                      style: 
                            'color:' +
                            _ctx.getNum(v.max_pss, v.old.max_pss, 'max_pss')[1]
                          
                                    }, _toDisplayString(_ctx.getNum(v.max_pss, v.old.max_pss, "max_pss")[0]), 5)
                                  ])
                                ]))
                              }), 128))
                            ]))
                          }), 128))
                        ])
                      ]))
                    }), 128)),
                    _createVNode("div", _hoisted_52, [
                      _hoisted_53,
                      _createVNode("table", _hoisted_54, [
                        _hoisted_55,
                        _createVNode("tbody", null, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.get_skin_data.device_list, (item, index) => {
                            return (_openBlock(), _createBlock("tr", { key: index }, [
                              _createVNode("td", null, _toDisplayString(item.level), 1),
                              _createVNode("td", null, _toDisplayString(item.model), 1),
                              _createVNode("td", null, _toDisplayString(item.os), 1),
                              _createVNode("td", null, _toDisplayString(item.gpu_name), 1),
                              _createVNode("td", null, _toDisplayString(item.frame_rate), 1),
                              _createVNode("td", null, _toDisplayString(item.resolution), 1)
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ])
                ]),
                _hoisted_56
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})